import { useState } from 'react';

export default function useIncrement(max = 1, increment = 10, initialCount = 10) {
  const [count, setCount] = useState(initialCount);

  function inc() {
    if (count >= max) return;
    setCount(old => Math.min(max, old + increment));
  }

  return [count, inc];
}
